module.exports = __webpack_public_path__ + "static/media/more.fe075177.svg";